import { Component, Input, OnInit, Output, EventEmitter, HostListener, ViewChild, ElementRef } from '@angular/core';
import { CitiShopPropsService } from '../../utility/citi-shop-props.service';

@Component({
  selector: 'app-citi-shop-speedbump-dialog',
  templateUrl: './citi-shop-speedbump-dialog.component.html',
  styleUrls: ['./citi-shop-speedbump-dialog.component.scss'],
  standalone: false,
  host: { 'class': 'cbolui-cds' }
})
export class CitiShopSpeedbumpDialogComponent implements OnInit  {
  @Input() showModal = false;
  @Input() dialogContent!: any;
  @Output() closeEmit: EventEmitter<any> = new EventEmitter();
  @Output() submitEmit: EventEmitter<any> = new EventEmitter();

  imageURL!: string;
  header!: string;
  announcement!: string;
  informationHeader!: string;
  informationContent!: string;
  speedBumpURL!: string;
  speedBumpButtonText!: string;
  closeButtonText!: string;
  @ViewChild('initialFocus') initialFocus: ElementRef;


  constructor(public csp: CitiShopPropsService) {}

  ngOnInit(): void {
    if (this.dialogContent) {
      this.setImageURL();
      this.header = this.dialogContent['header'];
      this.announcement = this.dialogContent['announcement'];
      this.informationHeader = this.dialogContent['informationHeader'];
      this.informationContent = this.dialogContent['informationContent'];
      this.speedBumpURL = this.dialogContent['speedBumpURL'];
      this.speedBumpButtonText = this.dialogContent['speedBumpButtonText'];
      this.closeButtonText = this.dialogContent['closeButtonText'];
    }
  }

  @HostListener('window:resize', ['$event'])
  setImageURL() {
    const windowWidth = window.innerWidth;
    if (windowWidth <= 767) {
      this.imageURL = this.csp.imagePrefix() + this.dialogContent['imageURLsm'];
    }
    else if (windowWidth >= 768 && windowWidth <=1024) {
      this.imageURL = this.csp.imagePrefix() + this.dialogContent['imageURLmd'];
    }
    else if (windowWidth > 1024 && windowWidth <=1440) {
      this.imageURL = this.csp.imagePrefix() + this.dialogContent['imageURLlg'];
    }
    else{
      this.imageURL = this.csp.imagePrefix() + this.dialogContent['imageURLxl'];
    }
  }

  open() {
    this.showModal = true;
    setTimeout(() => {
      (<HTMLButtonElement>this.initialFocus.nativeElement).focus();      
    }, 1000);
  }

  closeModal(val: any) {
    this.showModal = false;
    this.closeEmit.emit(val);
  }
}